/**
 * Faturamento Configuracao
 * @author Thacryba
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {Responsavel} from '@/model/resource/Responsavel'

export class ExportarRelatorioFaturamento extends Resource {
  idResponsavelFaturamentoConfiguracaoPk: number = 0

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  dataInicial: string | null = null
  dataFinal: string | null = null
  ehGrupoEconomico: boolean = false
  ativo: boolean = true

  get $id() {
    return this.idResponsavelFaturamentoConfiguracaoPk
  }
  set $id(val) {
    this.idResponsavelFaturamentoConfiguracaoPk = val
  }

  get idResponsavelFk() {
    if (!this.responsavel) return 0
    return this.responsavel.$id
  }
  set idResponsavelFk(val) {
    if (!this.responsavel) this.responsavel = new Responsavel()
    this.responsavel.$id = val
  }

  reset() {
    this.dataFinal = null
    this.dataInicial = null
    this.ehGrupoEconomico = false
    this.ativo = true
    this.idResponsavelFaturamentoConfiguracaoPk = 0
  }

  restart() {
    this.dataFinal = null
    this.dataInicial = null
    this.ehGrupoEconomico = false
    this.ativo = true
    this.responsavel = null
    this.idResponsavelFaturamentoConfiguracaoPk = 0
  }

  /**
   * Schedule the report on the requested days.
   */
  async exportReport() {
    return await Request.post(`/admin/faturamento/report/schedule`, this)
      .name('exportReportFaturamento')
      .asNumber()
      .getData()
  }
}
